import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import { getAllToolsApi } from './Api';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { TOOLS_VERIFY } from '../../utils/urls';
import { withRouter } from '../../utils/hoc/withRouter';
import { Tag } from 'antd';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';


class Tools extends Component {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.CalculatorCalculator);

        this.state = {
            access: AccesData,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,
            isVerify: false,
            show: false,
            verified: '',
            verifyUrl: ''
        }
    }

    componentDidMount() {
        const { history } = this.props;
        history({
            pathname: this.props.location.pathname,
            search: `?p=${this.state.currentPage || START_PAGE}`,
        });
        this.props.getAllToolsApi(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevVerified = prevParams.get("isVerified") || "";
        const prevSize = parseInt(prevParams.get("pageSize"), 10) || START_PAGE;

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        const verified = params.get("isVerified") || "";
        const size = parseInt(params.get("pageSize"), 10) || START_PAGE;

        // const search = params.get("search") || "";

        if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
            this.setState({ currentPage: page }, () => {
                this.props.getAllToolsApi(this);
            });
        }
    }

    showEditModal = (rowData = null) => {
        this.props.history({ pathname: `/calculator/edit/${rowData?.uuid}`, state: { "editData": rowData } })
        this.setState({
            showEdit: !this.state.showEdit,
            editData: rowData
        });
    };
    openCloseDeleteModal = (rowData) => {
        this.setState({
            delete: !this.state.delete,
            deleteData: rowData,
        });
    };
    deleteHandle = async (id) => {
        const res = await deleteAuthCommonApi(`/tools/${id}`);
        // console.log(res)
        if (res?.status === 200) {
            this.props.getAllToolsApi(this);
            this.setState({
                delete: !this.state.delete
            });

        } else {
            toast.error("Something is wrong...")
        }
    }
    render() {
        const { access } = this.state;
        const { toolsList, totalPages, currentPage } = this.props.toolsState || {};
        console.log(this.props.toolsState);
        // console.log('roleList', roleList);
        return (
            <>
                {this.state.delete && (
                    <InformationModal
                        show={this.state.delete}
                        id={this.state.deleteData?.uuid}
                        title={`Are you sure you want to delete ${this.state.deleteData?.toolName} ?`}
                        handleClose={this.openCloseDeleteModal}
                        handleDelete={this.deleteHandle}
                    />
                )}
                <VerifiedModal
                    // name={`this '${this.state.editData?.campaignName}' campaign.`}
                    name={`'${this.state.editData?.toolName}'`}
                    show={this.state.show}
                    url={TOOLS_VERIFY + `/${this.state?.editData?.uuid}`}
                    isVerified={this.state.isVerify}
                    handleCancel={() => { this.setState({ show: false }) }}
                    successRes={() => { this.props.getAllToolsApi(this) }}
                />
                <section className="request-section">
                    <ComponentHeader
                        title="Calculators"
                        breadcrumb={[["Calculators", ""]]}
                        ctx={this}
                    />
                    <Row>
                        <Col sm={2}>
                            <FilterVefiedDropDown ctx={this} />
                        </Col>
                    </Row>
                    <div className="commom-table-wrapper">
                        <CustomTable
                            ctx={this}
                            data={toolsList?.list || []}
                            columns={[
                                {
                                    width: 180,
                                    title: "Tools Name",
                                    dataIndex: "toolName",
                                    className: "name",
                                    render: (text, rowData, dataKey) => {
                                        return rowData?.toolName;
                                    },
                                },
                                {
                                    width: access.verificationAccess ? 110 : 0,
                                    title: "Verified",
                                    dataIndex: "isVerified",
                                    className: "verify",
                                    isCell: true,
                                    render: (text, rowData, dataKey) => {
                                        const color = rowData.isVerified ? 'green' : 'orange';
                                        return <div className=" d-flex align-items-center inter-medium">
                                            <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                                                <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                                            </Tag>
                                        </div>;
                                    },
                                },
                                {
                                    width: 150,
                                    title: "Thumbnail",
                                    dataIndex: "thumbnailPath",
                                    className: "logo",
                                    isCell: true,
                                    render: (text, rowData, dataKey) => {
                                        return <Image className="table-img" src={rowData?.thumbnailPath} alt="Company Logo" />;
                                    },
                                },
                                {
                                    width: 20,
                                    title: "Action",
                                    dataIndex: "",
                                    className: "",
                                    isCell: true,
                                    render: (text, rowData, dataKey) => {
                                        return (
                                            <>
                                                    <OptionsDropdown
                                                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                                                        deleteHandler={null || access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                                                    />
                                            </>

                                        );
                                    },
                                },
                            ]}

                            total={toolsList?.length || 0}
                            loading={this.state.isLoading}
                        />
                    </div>
                </section>
            </>
        )
    }
}

const mapStateToProps = state => ({
    toolsState: state.ToolsState
});
const mapDispatchToProps = {
    getAllToolsApi,
}
Tools.propTypes = {
    // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Tools));